import { ROOM_LABELS, ROOM_OPTIONS } from "#constants/classOptions"
import {
  FRONT_DESK_ROOM,
  HelpRequestRoom,
} from "#customTypes/composedTypes/helpRequestTypes"

export const HELP_REQUEST_ROOM_LABELS: Record<string, string> = {
  ...ROOM_LABELS,
  [FRONT_DESK_ROOM]: "Front Desk",
}

export const HELP_REQUEST_ROOM_OPTIONS = [
  ...ROOM_OPTIONS,
  { label: "Front Desk", value: FRONT_DESK_ROOM },
]

export const getRoomLabel = (room: HelpRequestRoom) =>
  HELP_REQUEST_ROOM_LABELS[room] ?? room
